// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"FullDealEntryPointDisclaimer_disclaimer__1sPI8"};